import React, { useState } from 'react';
import { MenuItem, Select } from '@mui/material';
import axiosInstance from '../../../http-common';
import dayjs from 'dayjs';

const ApprovalDropdown = ({
    id,
    row,
    api
}) => {
    const [selectedStatus, setselectedStatus] = useState("");
    return (
        <div>
            <Select
                id={`${id}`}
                value={selectedStatus}
                label="Approval Status"
                size='small'
                onChange={async (e) => {
                    if (e.target.value === "approve") {
                        try {
                            const formattedRow = {
                                ...row,
                                machine_start_time: dayjs(row.machine_start_time).format('YYYY-MM-DD HH:mm:ss'),
                                machine_end_time: dayjs(row.machine_end_time).format('YYYY-MM-DD HH:mm:ss'),
                                pre_start_time: dayjs(row.pre_start_time).format('YYYY-MM-DD HH:mm:ss'),
                                pre_end_time: dayjs(row.pre_end_time).format('YYYY-MM-DD HH:mm:ss'),
                            };
                            const newArray = [formattedRow];
                            let result = await axiosInstance.post("/v1/qc/approve_schedule/", newArray);
                            setselectedStatus(e.target.value);
                            console.log(result);
                        } catch (error) {
                            console.log(error);
                        }
                    } else {
                        setselectedStatus(e.target.value);
                        console.log(row);
                    }
                }}
                displayEmpty
            >
                <MenuItem value="" disabled>Pending</MenuItem>
                <MenuItem value="approve">Approve</MenuItem>
                {/* <MenuItem value="reject">Reject</MenuItem> */}
            </Select>
        </div>
    );
};

export default ApprovalDropdown;
